var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"arrow","d":"M3.626,7.251,0,3.626,3.626,0","transform":"translate(5.04 8.666) rotate(180)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"2"}));
}

ArrowInline.defaultProps = {"width":"6.04","height":"10.08","viewBox":"0 0 6.04 10.08"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
